'use client'

import { captureException } from '@sentry/nextjs'
import { ArrowLeft, RotateCw } from 'lucide-react'
import { useEffect } from 'react'
import { recoverStaleServerAction } from '@/helpers/recover-stale-server-action'

export default function ErrorPage({
  error,
}: {
  error: Error & { digest?: string }
}) {
  useEffect(() => {
    // Aba com Server Action de build antigo: recarrega para pegar IDs novos.
    if (recoverStaleServerAction(error)) {
      return
    }

    // Report the error so an intermittent 500 leaves a trace in Sentry.
    // In the App Router, the server-side stack (unity vs products, upstream
    // status, etc.) is captured by `onRequestError` in `instrumentation.ts`;
    // this client capture adds the URL + `digest` so both events can be
    // correlated for the exact request that failed.
    captureException(error, {
      level: 'error',
      tags: {
        errorBoundary: 'app/error.tsx',
      },
      extra: {
        digest: error.digest,
        message: error.message,
        url: window.location.href,
        pathname: window.location.pathname,
        search: window.location.search,
      },
    })
  }, [error])

  return (
    <section className="container">
      <div className="flex h-screen flex-col items-center justify-center text-center">
        <h1 className="font-semibold text-4xl text-purple-400">
          500 | Erro Interno do Servidor
        </h1>
        <p className="font-medium text-[#858586]">
          Ocorreu um erro inesperado. Por favor, tente novamente mais tarde.
        </p>
        <div>
          <strong className="font-medium">Tentar Novamente</strong>
          <button
            className="mx-auto block"
            onClick={() => window.location.reload()}
            type="button"
          >
            <RotateCw className="-rotate-0 mx-auto transition-transform duration-300 ease-in hover:rotate-180" />
          </button>
        </div>

        <div className="mt-6">
          <strong className="font-medium">Voltar</strong>
          <button
            className="mx-auto block"
            onClick={() => window.history.back()}
            type="button"
          >
            <ArrowLeft className="-rotate-0 hover:-translate-x-1 mx-auto cursor-pointer transition-transform duration-300 ease-in" />
          </button>
        </div>
      </div>
    </section>
  )
}
